const properties = `url
download
name
`

export default properties
